import { render, staticRenderFns } from "./ResourceUploader.vue?vue&type=template&id=06f9405a&scoped=true&"
import script from "./ResourceUploader.js?vue&type=script&lang=js&"
export * from "./ResourceUploader.js?vue&type=script&lang=js&"
import style0 from "./ResourceUploader.vue?vue&type=style&index=0&id=06f9405a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9405a",
  null
  
)

export default component.exports